/**
 * Toggle
 * ======================================
 * - toggle [hidden] attribute on [data-toggle] selector
 * - toggle ELEMENT_LABEL text with [data-toggle-label] attribute
 */

 const ELEMENTS = ".js-toggle";
 const ELEMENT_LABEL = ".js-toggle-label";
 const TOGGLE_CLASS = "is-toggled";

 class Toggle {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS);

     if (!this.elements) {
       return false;
     }

     this.elements.forEach((el) => {
       el.addEventListener("click", this.toggle);
     });
   }

   toggle = (e) => {
     const el = e.currentTarget;
     const label = el.querySelector(ELEMENT_LABEL);
     const currentLabel = label.innerHTML;
     const newLabel = el.getAttribute("data-toggle-label");
     const target = document.querySelector(el.getAttribute("data-toggle"));

     if (!target) {
       return false;
     }

     if (newLabel) {
       label.innerHTML = newLabel;
       el.setAttribute("data-toggle-label", currentLabel);
     }

     target.toggleAttribute("hidden");
     el.classList.toggle(TOGGLE_CLASS);

     e.preventDefault();
   };
 }

 new Toggle();
